import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function PaymentResult({ kind }) {
    const loc = useLocation();
    const nav = useNavigate();
    const [status, setStatus] = useState(kind === "success" ? "polling" : "cancelled");

    useEffect(() => {
        if (kind !== "success") return;
        const params = new URLSearchParams(loc.search);
        const sid = params.get("session_id");
        if (!sid) { setStatus("unknown"); return; }
        let polls = 0;
        const tick = async () => {
            polls += 1;
            try {
                const { data } = await api.get(`/payments/status/${sid}`);
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    toast.success("Payment confirmed. Invoice marked paid.");
                    return;
                }
                if (data.payment_status === "failed" || data.payment_status === "expired") {
                    setStatus(data.payment_status); return;
                }
            } catch {}
            if (polls < 15) setTimeout(tick, 2000);
            else setStatus("timeout");
        };
        tick();
    }, [kind, loc.search]);

    return (
        <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--gt-bg)" }}>
            <div className="gt-card p-8 max-w-md w-full text-center" data-testid={`payment-${kind}`}>
                <div className="mb-4" style={{ fontSize: 36, color: kind === "success" ? "var(--gt-ok)" : "var(--gt-warn)" }}>
                    <i className={kind === "success" ? "fa-solid fa-circle-check" : "fa-solid fa-circle-xmark"}></i>
                </div>
                <h1 className="font-display text-2xl mb-2">
                    {status === "paid" && "Payment confirmed"}
                    {status === "polling" && "Verifying payment…"}
                    {status === "cancelled" && "Payment cancelled"}
                    {status === "failed" && "Payment failed"}
                    {status === "expired" && "Session expired"}
                    {status === "timeout" && "Still processing"}
                    {status === "unknown" && "No session"}
                </h1>
                <p className="text-sm mb-6" style={{ color: "var(--gt-text-2)" }}>
                    {status === "paid" && "The invoice is marked paid in Trenton's dashboard."}
                    {status === "polling" && "Checking with Stripe. This usually takes 2–5 seconds."}
                    {status === "cancelled" && "No charge was made. You can try again from the invoice link."}
                    {status === "failed" && "The payment did not go through."}
                    {status === "expired" && "The checkout session timed out. Request a new link."}
                    {status === "timeout" && "Stripe is slow to confirm — refresh in a moment."}
                    {status === "unknown" && "Direct access detected. Return home."}
                </p>
                <button onClick={() => nav("/")} className="gt-btn-primary px-5 py-2 text-sm" data-testid="payment-home-btn">
                    Return home
                </button>
            </div>
        </div>
    );
}
